import ScenePage2 from './ScenePage2';

export default ScenePage2;
